export default __webpack_public_path__ + "static/media/DHL.33249f31.svg";